import { render, staticRenderFns } from "./core.vue?vue&type=template&id=adb26584&"
import script from "./core.vue?vue&type=script&lang=js&"
export * from "./core.vue?vue&type=script&lang=js&"
import style0 from "./core.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports